// elements
import radio from './elements/radio.js'
import input from './elements/input.js'
import internalLink from './elements/internalLink.js'
import externalLink from './elements/externalLink.js'

// modules
import formResourcesManager from './formResourcesManager.js'

var linkElement = function (options) {
	return {
		init: function () {
			this.wrapper = options.mainContainer
			this.callback = options.callback
			this.settings = options.settings
			this.name = options.name
			this.currentLang = options.currentLang

			this.internalLinks = null

			if (formResourcesManager.resources.data) {
				if (Object.keys(formResourcesManager.resources.data).length > 0) this.internalLinks = formResourcesManager.resources.dat
			}
			this.internalLinksFetchStarted = false
			this.internalLinksComponent = null

			if (this.isJson(options.value)) {
				this.value = JSON.parse(options.value)
			} else {
				this.value = options.value
			}

			// when no linksettings have been defined we just show them all
			if (!this.settings.linksettings) {
				this.settings['linksettings'] = {
					id: 0,
					name: 'linksettings',
					state: 3,
					value: '["Internal","External","Asset","Page"]'
				}
			}

			if (this.isJson(this.settings.linksettings.value)) {
				this.optionsToRender = JSON.parse(this.settings.linksettings.value)
			} else {
				this.optionsToRender = this.settings.linksettings.value
			}

			this.setupRadios()

			// check which conditional fields we need to render
			for (var i = 0; i < this.optionsToRender.length; i++) {
				this.renderConditionalField(this.optionsToRender[i])
			}
		},

		setupRadios: function () {
			var list = document.createElement('ul')
			list.classList.add('options')

			var options = ['None']
			options = options.concat(this.optionsToRender)
			for (var i = 0; i < options.length; i++) {
				var checked = false
				var index = -1
				if (this.value) {
					index = this.value.indexOf(options[i])
				} else {
					// set None default checken when there is no value
					if (options[i] === 'None') checked = true
				}
				if (index > -1) checked = true

				var listItem = radio({
					'checked': checked,
					'value': options[i],
					'label': options[i],
					'name': this.name
				}).init()

				list.appendChild(listItem)

				// add event listener
				listItem.addEventListener('change', this.radioClickhandler.bind(this))

				if (i === options.length - 1) {
					this.wrapper.appendChild(list)
					this.callback(this.conditionalLinkData, this.name)
				}
			}
		},

		renderConditionalField: function (field) {
			var nestedWrapper = document.createElement('div')
			nestedWrapper.classList.add('nested-wrapper')
			nestedWrapper.classList.add('link-' + field)
			nestedWrapper.classList.add('hidden')
			this.wrapper.appendChild(nestedWrapper)

			if (this.value) {
				this.evaluateContainerVisibility(this.value[0])
			}

			var disabled = true
			var valueToPrefill = null

			switch (field) {
				case 'Internal':
					if (this.value) {
						if (this.value[0] === 'Internal') {
							disabled = false
							valueToPrefill = [this.value[1], this.value[2], this.value[3]]
							this.fetchInternalLinks()
						}
					}
					this.internalLinksComponent = internalLink({
						'wrapper': nestedWrapper,
						'name': this.name,
						'disabled': disabled,
						'valueToPrefill': valueToPrefill,
						'currentLang': this.currentLang
					})
					this.internalLinksComponent.init()
					break
				case 'External':
					if (this.value) {
						if (this.value[0] === 'External') {
							disabled = false
							valueToPrefill = [this.value[1], this.value[2]]
						}
					}
					externalLink({
						'wrapper': nestedWrapper,
						'name': this.name,
						'disabled': disabled,
						'valueToPrefill': valueToPrefill
					}).init()
					break
				case 'Asset':
					if (this.value) {
						if (this.value[0] === 'Asset') {
							disabled = false
							valueToPrefill = this.value[1]
						}
					}
					input({
						'wrapper': nestedWrapper,
						'type': 'text',
						'name': this.name,
						'placeholder': 'Link label',
						'disabled': disabled,
						'valueToPrefill': valueToPrefill,
						'description': 'The link to the actual Showpad Asset (e.g. PDF) needs to be configurated in the Showpad backend.'
					}).init()
					break
				case 'Page':
					if (this.value) {
						if (this.value[0] === 'Page') {
							disabled = false
							valueToPrefill = this.value[1]
						}
					}
					input({
						'wrapper': nestedWrapper,
						'type': 'text',
						'name': this.name,
						'placeholder': 'Link label',
						'disabled': disabled,
						'valueToPrefill': valueToPrefill,
						'description': 'The link to the actual Showpad Page needs to be configurated in the Showpad backend.'
					}).init()
					break
			}
		},

		radioClickhandler: function (e) {
			e.stopImmediatePropagation()
			var target = e.currentTarget

			// find radio
			var radio = target.querySelector('input')
			var value = radio.value

			// find the nested wrapper to unhide and hide the others
			this.evaluateContainerVisibility(value)
		},

		evaluateContainerVisibility: function (value) {
			var nestedWrappers = this.wrapper.querySelectorAll('.nested-wrapper')

			for (var i = nestedWrappers.length - 1; i >= 0; i--) {
				if (nestedWrappers[i].classList.contains('link-Internal') && value === 'Internal') {
					this.fetchInternalLinks()
				}
				var className = 'link-' + value
				if (nestedWrappers[i].classList.contains(className)) {
					nestedWrappers[i].classList.remove('hidden')
					var inputs = nestedWrappers[i].querySelectorAll('input, select')
					for (var o = inputs.length - 1; o >= 0; o--) {
						inputs[o].removeAttribute('disabled')
					}
				} else {
					nestedWrappers[i].classList.add('hidden')
					var inputs1 = nestedWrappers[i].querySelectorAll('input, select')
					for (var p = inputs1.length - 1; p >= 0; p--) {
						inputs1[p].setAttribute('disabled', 'true')
					}
				}
			}
		},

		fetchInternalLinks: function () {
			if (!this.internalLinks && !this.internalLinksFetchStarted) {
				formResourcesManager.fetchResources(this.internalLinksFetched.bind(this))
			} else {
				this.internalLinksFetched(this.internalLinks)
			}

			this.internalLinksFetchStarted = true
		},

		internalLinksFetched: function (data) {
			this.internalLinks = data
			formResourcesManager.resources.data = this.internalLinks
			if (!this.internalLinksComponent) return
			this.internalLinksComponent.setLinksData(this.internalLinks)
		},

		isJson: function (str) {
			try {
				JSON.parse(str)
			} catch (e) {
				return false
			}
			return true
		}
	}
}

export default linkElement
